
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./ledger-bridge.cjs.production.min.js')
} else {
  module.exports = require('./ledger-bridge.cjs.development.js')
}
